export const REGISTRATION_SUCCESS = 'registrationSuccess';
export const WAITINGLIST_SUCCESS = 'waitingListSuccess';
export const WAITING_LIST = 'WAITING_LIST';
export const REGISTERED = 'REGISTERED';
export const SELF_CHECKIN = 'SELF_CHECKIN';
export const CHECKIN = 'CHECKIN';
